import React, { Component } from "react"
import { connect } from 'react-redux'
import moment from 'moment'
import $ from 'jquery'
import { Div, Input, DatePicker, Select, TextArea, DropDownList, InputDecimal } from "../core";
import utilityHelper from '../../helpers/helperUtil'
import {
    createUserManualAction,
    clearErrorMsgAction
} from '../../redux/actions/UserManualAction'
import { Constants, MessageText, Storage } from '../../configs'
import { msg } from '../Notifications/MsgBox';
import { async } from "q";
import { getAllOrgUnitsAction } from "../../redux/actions/MasterAction";
import {
    setKeyValueAction as setKeyValueEmployeeModalAction,
    clearModalAction as clearEmployeeModalAction,
} from '../../redux/actions/ModalEmployeeAction'
import {
    clearSearchDirectoryInfoAction,
} from '../../redux/actions/MasterAction'
import unitCodeReviewer from '../../configs/datas/unitcode_reviewer'
import { addMYearEndPOAction, getMYearEndPOAction, uploadYearEndPOContract, downloadYearEndPOContract,saveAll } from '../../redux/actions/ContractPOAction'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from "@material-ui/core/TablePagination";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from '@material-ui/core/Paper';
class LockPOModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props,
            lockPOModal: {},
            isView: false,
            file: null,
            showResult: false,
            SuccessResult: null,
            page: 0,
            rowsPerPage: 10,
        }

        this.handleChange = this.handleChange.bind(this)
        this.onClickHandler = this.onClickHandler.bind(this)
        this.onSaveHandler = this.onSaveHandler.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.handleLockStatusChange = this.handleLockStatusChange.bind(this)
    }
    closeModal() {
        this.setState({
            showResult: false
        })

        window.$('#lockPOModal').modal('hide')

    }
    async handleChange(event) {
        const { name, value, files } = event.target;

        if (name !== "file") {
            await this.setState({ [name]: value })
        }
        else {
            let fileSp = value.split("\\");
            let title = fileSp.length > 0 ? fileSp[fileSp.length - 1] : "";

            await this.setState({
                ...this.state,
                "file": files[0],
                "title": title
            })
        }


    }

    validateFileUpload() {
        try {
            let { file } = this.state
            if (file != "") {

                if (file == null) {
                    msg.error('กรุณาเลือกไฟล์ที่ต้องการอัพโหลด')
                    return false
                }

                return true;
            }
            else {
                msg.error('กรุณาเลือกไฟล์ที่ต้องการอัพโหลด')
                return false
            }

        } catch (error) {

        }

        return false
    }

    async onClickHandler() {
        let { file, showResult } = this.state;
        let { onUploadComplete, uploadResult } = this.props;
        const isValid = this.validateFileUpload()
        const user = Storage.getUser()
        let localuser = "admin"
        let unitCode = "";
        if (user) {
            localuser = user.userName
            unitCode = user.unitCode;
        }

        if (isValid) {
            const data = new FormData()
            await

                data.append('file', file)
            data.append('user', localuser)
            data.append('unitCode', unitCode)

            this.props.uploadYearEndPOContract(data).then(() => {
                if (this.props.uploadResult.success === true) {

                    // onUploadComplete();
                    // console.log('this.props.uploadResult.successResult==>', this.props.uploadResult.successResult)
                    let uploadResult=this.props.uploadResult;
                    uploadResult.successResult = uploadResult.successResult.map((row, runing) => { return {...row,index:runing}})
                    this.setState({ SuccessResult: uploadResult.successResult });
                    this.setState({ showResult: true });
                }


            }).catch(error => console.log("error : " + error));



        }

    }
    async onSaveHandler() {
        let {SuccessResult } = this.state;
        
        let { onUploadComplete, uploadResult } = this.props;

        SuccessResult = SuccessResult.filter(function(item){
            return item.status == "Success";         
        })
        await this.props.saveAll(SuccessResult);
        
        if(this.props.saveUploadResult.isSuccess==true){
            msg.success(MessageText.PAGE.CONTRACTPOMANAGE.POPUP_MSG_SUCCESS_SAVE)
            this.closeModal();
            onUploadComplete();
        }else{
            msg.error(this.props.saveUploadResult.returnMessage)
        }

    }

    handleChangePage(event, newPage, pageName) {
        this.setState({
            [pageName]: newPage
        })
    }

    handleChangeRowsPerPage(event, pageName, rowsPerPageName) {
        this.setState({
            [rowsPerPageName]: +event.target.value,
            [pageName]: 0
        })
    }
    handleLockStatusChange(event, dat) {

        const user = Storage.getUser()
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;
        var __FOUND = this.state.SuccessResult.findIndex(function (post, index) {
            if (post.po_contract_no == dat.po_contract_no && post.index == dat.index)
                return true;
        });


        let datas = [...this.state.SuccessResult];

        let data = { ...datas[__FOUND] };

        data.lock_status = value;
        data.updateBy = user.userName;
        datas[__FOUND] = data;
        
        this.setState({ SuccessResult: datas });

        this.props.addMYearEndPO(data);




    }
    render() {
        const roleAdmin = Storage.getRoleAdmin()
        const { title, detail, file, showResult, SuccessResult, page, rowsPerPage } = this.state
        const { uploadResult } = this.props
        const { countSuccess, countFail } = uploadResult
        
        return (
            <div className="modal fade sp-modal rrs-modal" id="lockPOModal" tabIndex={-1} role="dialog" aria-labelledby="lockPOModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="lockPOModalLabel">Upload PO / Contract</h5>
                            <button type="button" className="close" data-dismiss="modal" onClick={this.closeModal} aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ 'padding': '2rem' }}>

                            {showResult === false ? (

                                <div>
                                    <div className="rrs-detail-data sp-table-container">
                                        <div className="row">
                                            <div className="col-12 d-flex align-items-center">
                                                <i className="icon btn-plus" />
                                                <span className="ml-3">Browse file here  <small>(The maximum file size is 50 MB)</small></span>
                                            </div>
                                        </div>
                                        <div className="rrs-file-browse">
                                            <input accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" type="file" id={`file`} name="file" onChange={(event) => this.handleChange(event)} key={this.state.inputKey} />
                                        </div>

                                    </div>
                                    <div className="row mx-0 header-button-row mt-3">
                                        <div className="col-12 sp-header-button-panel2">
                                            <button href="#" className="sp-btn-icon btn-del" data-dismiss="modal" onClick={this.closeModal}>
                                                <i className="icon btn-cancel"></i><span className="sp-btn-icon-label">Cancel</span>
                                            </button>
                                            <button href="#" className="sp-btn-icon" onClick={this.onClickHandler}>
                                                <i className="icon btn-order-check-green"></i><span className="sp-btn-icon-label">Ok</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div style={{ 'paddingLeft': '0', 'paddingRight': '0' }}>
                                        <div className="rrs-detail2">
                                            <div style={{ 'paddingLeft': '47px' }}>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="rrs-detail-data">
                                                            <label htmlFor="gr_delivery_note" className="rrs-label mb-0">Upload Success: </label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="rrs-detail-data">
                                                            <span className="ml-3" style={{ color: '#39B54A' }}>{countSuccess}</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="rrs-detail-data">
                                                            <span className="ml-3">รายการ</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="rrs-detail-data">
                                                            <label htmlFor="gr_delivery_note" className="rrs-label mb-0">Upload Fail: </label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="rrs-detail-data">
                                                            <span className="ml-3" style={{ color: '#E63730' }}>{countFail}</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="rrs-detail-data">
                                                            <span className="ml-3">รายการ</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row" style={{ "paddingBottom": "10px" }}></div>
                                            <div className="sp-table-container">
                                                <div>

                                                    <Table className="sp-table table rrs-table" >
                                                        <TableHead>
                                                            <TableRow className="sp-table-header">
                                                                <TableCell className="th-table text-center" style={{ width: '100px' }} >PO/Contract No.</TableCell>
                                                                <TableCell className="th-table text-center" style={{ width: '200px' }}>สถานะ Lock PO / Contract No.</TableCell>
                                                                <TableCell className="th-table text-center" style={{ width: '50px' }}>Status</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {

                                                                SuccessResult ? (
                                                                    SuccessResult.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                        .map((task, index) => {
                                                                            return (
                                                                                <TableRow key={index}>

                                                                                    <TableCell className="th-table text-center" style={{ width: '100px' }} >{task.po_contract_no}</TableCell>
                                                                                    { (task.lock_status=="N" ||task.lock_status=="Y")  ? (                                                                                    <TableCell className="th-table text-center" style={{ width: '200px' }}>
                                                                                        <div class="row">
                                                                                            <div className="col-md-2"/>
                                                                                            <div className="col-md-4">
                                                                                                <label className="radiocontainer">Lock
                                                                                                    <input
                                                                                                        name={"modal_lockStatus" + index}
                                                                                                        type="radio"
                                                                                                        value={"Y"}
                                                                                                        checked={task.lock_status === "Y"}
                                                                                                        onChange={(e) => this.handleLockStatusChange(e, task)}
                                                                                                        disabled={task.status=="Success"?false:true}
                                                                                                    />
                                                                                                    <span className="checkmark" />
                                                                                                </label>
                                                                                            </div>
                                                                                            <div className="col-md-4">
                                                                                                <label className="radiocontainer">Unlock
                                                                                                    <input
                                                                                                        name={"modal_lockStatus" + index}
                                                                                                        type="radio"
                                                                                                        value={"N"}

                                                                                                        checked={task.lock_status === "N"}
                                                                                                        onChange={(e) => this.handleLockStatusChange(e, task)}
                                                                                                        disabled={task.status=="Success"?false:true}
                                                                                                    />
                                                                                                    <span className="checkmark" />
                                                                                                </label>
                                                                                            </div>
                                                                                            <div className="col-md-2"/>
                                                                                        </div>
                                                                                    </TableCell>) : <TableCell className="th-table text-center" style={{ textAlign: 'left' }}  >{task.lock_status}</TableCell>}

                                                                                    <TableCell className="th-table text-center" style={{ textAlign: 'left', "whiteSpace": "nowrap" }}  >{task.status}</TableCell>
                                                                                </TableRow>
                                                                            );
                                                                        })) : (
                                                                    <TableRow key={0}>
                                                                        <TableCell colSpan="11" className="text-center" style={{
                                                                            textAlign: 'center',
                                                                            fontStyle: 'italic',
                                                                            color: 'gray'
                                                                        }}>No data</TableCell>
                                                                    </TableRow>
                                                                )
                                                            }
                                                        </TableBody>
                                                    </Table>
                                                    <TablePagination
                                                        rowsPerPageOptions={[10, 25, 50, 100]}
                                                        component="div"
                                                        count={SuccessResult ? SuccessResult.length : 0}
                                                        rowsPerPage={this.state.rowsPerPage}
                                                        page={this.state.page}
                                                        backIconButtonProps={{
                                                            'aria-label': 'previous page',
                                                        }}
                                                        nextIconButtonProps={{
                                                            'aria-label': 'next page',
                                                        }}
                                                        onChangePage={(event, newPage) => this.handleChangePage(event, newPage, "page")}
                                                        onChangeRowsPerPage={(event) => this.handleChangeRowsPerPage(event, "page", "rowsPerPage")}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mx-0 header-button-row mt-3">
                                        <div className="col-12 sp-header-button-panel2">
                                            <button href="#" className="sp-btn-icon btn-del" data-dismiss="modal" onClick={this.closeModal}>
                                                <i className="icon btn-order-delete"></i><span className="sp-btn-icon-label">Close</span>
                                            </button>
                                            {countSuccess > 0 ?(<button href="#" className="sp-btn-icon" onClick={this.onSaveHandler}>
                                                <i className="icon btn-order-savedraft"></i><span className="sp-btn-icon-label">Save</span>
                                            </button>):<div/>}

                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>

        )

    }
}


const mapStateToProps = state => {
    const { ContractPORedux } = state
    return {
        resultSearch: ContractPORedux.contractPOData,
        resultExport: ContractPORedux.resultExport,
        uploadResult: ContractPORedux.uploadResult,
        saveUploadResult: ContractPORedux.saveUploadResult
    }
}
const mapDispatchToProps = dispatch => {
    return {
        uploadYearEndPOContract: (data) => dispatch(uploadYearEndPOContract(data)),
        addMYearEndPO: (model) => dispatch(addMYearEndPOAction(model)),
        saveAll:(model)=>dispatch(saveAll(model)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LockPOModal)